import { Maintenance } from '@bzbs/react-api-client';
import { create } from 'zustand';
import { useBuzzebeesAppStore } from './buzzebeess-app.store';

export type MaintenanceState = {
  isMaintenance: boolean | null;
  maintenanceData: Maintenance | null;
};

export type MaintenanceActions = {
  checkMaintenance: () => Promise<void>;
};

export type MaintenanceStore = MaintenanceState & MaintenanceActions;

export const useMaintenanceStore = create<MaintenanceStore>((set) => ({
  isMaintenance: null,
  maintenanceData: null,

  checkMaintenance: async () => {
    const bzbsService = useBuzzebeesAppStore.getState().bzbsService;
    const appId = useBuzzebeesAppStore.getState().appId;

    if (!bzbsService || !appId) {
      return;
    }

    const result = await bzbsService.blob.maintenance(appId);
    if (result.type === 'success') {
      if (result.model.enabled === true) {
        set({
          isMaintenance: true,
          maintenanceData: result.model,
        });
      } else {
        set({
          isMaintenance: false,
          maintenanceData: null,
        });
      }
    } else {
      set({
        isMaintenance: false,
        maintenanceData: null,
      });
    }
  },
}));
